import { gql } from '@apollo/client'
import { GrowthBook } from '@growthbook/growthbook'
import { initializeApollo } from '@jusbrasil-web/shared-apollo-client'
import { ArgosClient } from '@jusbrasil-web/shared-argos-client'
import { GetServerSidePropsContext } from 'next'

import {
  GROWTHBOOK_ATTRIBUTES,
  GROWTHBOOK_EXPERIMENT_EVENT_NAME,
  GROWTHBOOK_INTERNAL_STATE,
} from '../constants'
import { AppPropsWithGrowthBook, WithGrowthBook } from '../types'

const CLIENT_KEY = process.env.GROWTHBOOK_CLIENT_KEY || ''
const API_HOST = process.env.GROWTHBOOK_API_HOST || 'http://localhost:3300'
const ENABLE_DEV_MODE = process.env.NEXT_PUBLIC_GROWTHBOOK_DEV_MODE === 'true'

const GET_PROFILE_FOR_GROWTH_BOOK = gql`
  query getProfileForGrowthBook {
    root {
      viewer: me {
        pid
        user {
          email
          isAdmin
        }
      }
    }
  }
`

export const withGrowthBook: WithGrowthBook = async (ctx: GetServerSidePropsContext) => {
  const argosClient = new ArgosClient()
  const apolloClient = initializeApollo({}, ctx.req)

  const { data } = await apolloClient.query({
    query: GET_PROFILE_FOR_GROWTH_BOOK,
  })
  const viewer = data?.root?.viewer || {}
  const { pid, user } = viewer || {}
  const jdid = ctx.req?.cookies?.jdid || null
  const attributes = {
    pid: pid || null,
    email: user?.email ?? null,
    is_admin: !!user?.isAdmin,
    device_id: jdid,
  }

  const client = new GrowthBook({
    apiHost: API_HOST,
    clientKey: CLIENT_KEY,
    enableDevMode: ENABLE_DEV_MODE,
    attributes,
    trackingCallback: (experiment, result) =>
      argosClient.send(pid?.toString(), GROWTHBOOK_EXPERIMENT_EVENT_NAME, {
        experiment: experiment.name,
        alternative: result.name,
        device_id: jdid,
      }),
  })

  if (pid || jdid) await client.init({ timeout: 1000 })

  return {
    client,
    withGrowthBookProps() {
      const features = client.getFeatures() || {}

      const props: AppPropsWithGrowthBook = {
        [GROWTHBOOK_INTERNAL_STATE]: features,
        [GROWTHBOOK_ATTRIBUTES]: client.getAttributes(),
      }
      client.destroy()
      return props
    },
  }
}
